import { render } from "./CertColorBox.vue?vue&type=template&id=f0e699ba"
import script from "./CertColorBox.vue?vue&type=script&lang=js"
export * from "./CertColorBox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__